// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Link from "next/link";

// lib files
import { SearchWebResultType } from "@/lib/types/search/results";
import { PromotedResultType } from "@/lib/content-services/search/promotedResults";

// components
import ITSImage from "@/components/ITSImage/ITSImage";

// styles
import styles from './SearchWebThumbnail.module.scss';

interface SearchWebThumbnailProps {
  data: SearchWebResultType | PromotedResultType;
}

export default function SearchWebThumbnail(props: SearchWebThumbnailProps) {
  const { data } = props;
  const {
    title,
    external_url,
    image_url
  } = data;

  if(Object.hasOwn(data, 'description_short')) {
    var description = (data as SearchWebResultType).description_short
  } else {
    var description = (data as PromotedResultType).description
  }

  // default for images for web results - if they are not ITS images
  let linkWithImageStyle: React.CSSProperties = {backgroundColor: `#fff`, padding: `12px`};

  // if they *are* ITS images, we add the image itself as a blurred background
  if (image_url?.includes('image.pbs.org')) {
    linkWithImageStyle = {backgroundImage: `url(${`${image_url}?blur=20`})`}
  }

  // special case for PBS KIDS - adding a yellow background from their style guide
  // https://pbs-kids-brand.pbskids.org/downloads/pbs-kids-style-guide.pdf
  if (title?.toLowerCase().trim() === "pbs kids") {
    linkWithImageStyle = {backgroundColor: `#F7E03B`, padding: `12px`};
  }

  return (
    <div className={styles.search_web_thumbnail__container} data-sentry-component="SearchWebThumbnail" data-sentry-source-file="SearchWebThumbnail.tsx">
      <div className={styles.search_web_thumbnail}>
        {image_url ?
          <Link
            href={external_url}
            style={linkWithImageStyle}
            className={styles.search_web_thumbnail__link}
          >
            <ITSImage
              src={image_url}
              alt=''
              width={500}
              className={styles.search_web_thumbnail__image}
            />
          </Link>
          :
          <Link
            href={external_url}
            className={styles.search_web_thumbnail__fallback_link}
          />
        }
        <h3 className={styles.search_web_thumbnail__title}>
          <Link href={external_url} data-sentry-element="Link" data-sentry-source-file="SearchWebThumbnail.tsx">{title}</Link>
        </h3>
        <p className={styles.search_web_thumbnail__description}>
          {description}
        </p>
      </div>
    </div>
  )
}
